import "css/shippingResponsive.css";
import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { ENDPOINT } from "constants/variables";
import { es } from 'date-fns/locale';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Container from '@mui/material/Container';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import TextField from '@mui/material/TextField';
import "css/generalSettings.css";
import "css/customDialog.css";
import { warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import { setLoading } from 'reducers/loadingSlice';
import { LoadingNews } from "components/utils/LoadingNews";
import TableSortingShippingFormDI from "pages/shipping/editOrNewShipping/SortingTablesShippingFormDI";
import PropTypes from 'prop-types';
const initialFiltersFormDI = {
  "idFrom": "",
  "idTo": "",
  "preiddocSheetFrom": "",
  "preiddocSheetTo": "",
  "sufiddocSheetFrom": "",
  "sufiddocSheetTo": "",
  "numberDTFrom": "",
  "numberDTTo": "",
  "dateSheetFrom": null,
  "dateSheetTo": null
};
const initialStateFormDI = [{
  "id": 0,
  "ownformdi_id": 0,
  "preiddoc_sheet": "",
  "sufiddoc_sheet": "",
  "number_dt": "",
  "date_sheet": "",
  "rel_trans_store_id": "",
  "rel_trans_documentid": "",
  "rel_trans_tradename": "",
  "rel_trans_street": "",
  "vehiclestore_licenseplate": "",
  "opt_tras_store_id": 0,
  "opt_tras_documentid": "",
  "opt_tras_tradename": "",
  "opt_tras_street": "",
  "dest_tras_store_id": 0,
  "dest_tras_documentid": "",
  "dest_tras_tradename": "",
  "dest_tras_street": "",
  "delivery_quantity": 0,
  "codeler_id": 0,
  "dest_tras_paymenttype_id": 1
}];
const ShippingSearchDI = ({
  showModalSearchDI,
  setShowModalSearchDI,
  formShipping,
  setFormShipping,
  menuPermissions
}) => {
  const LIMITPAGESIZE = useSelector(state => state.loginUser.defaultticketsformat.limitpagesize);
  const {
    t,
    i18n
  } = useTranslation(['listDataShipping']);
  const token = useSelector(state => state.loginUser.token);
  const defaultStore = useSelector(state => state.loginUser.defaultStore);
  const [dataFormDI, setDataFormDI] = useState(initialStateFormDI);
  const [isLoadingErrorFormDI, setIsLoadingErrorFormDI] = useState(false);
  const isLoading = useSelector(state => state.loading.isLoading);
  const [inputTextFormDI, setInputTextFormDI] = useState("");
  const [applyFiltersFormiDI, setApplyFiltersFormiDI] = useState(initialFiltersFormDI);
  const [filtersFormDI, setFiltersFormDI] = useState(initialFiltersFormDI);
  const [openEditFilterFormDI, setOpenEditFilterFormDI] = useState(false);
  const [errorsfiltersFormDI, seterrorsfiltersFormDI] = useState({});
  const [numTotRegFilter, setNumTotRegFilter] = useState(0);
  const [numTotRegFormDI, setNumTotRegFormDI] = useState(0);
  const [activeOffsetFormDI, setActiveOffsetFormDI] = useState(false);
  const [currencyOffsetFormDI, setCurrencyOffsetFormDI] = useState(0);
  const [rangeOffsetFormDI, setRangeOffsetFormDI] = useState([{}]);
  const dispatch = useDispatch();
  const handleCloseDataEditFormDI = () => {
    setDataFormDI(initialStateFormDI);
    setIsLoadingErrorFormDI(false);
    dispatch(setLoading(false));
    setInputTextFormDI("");
    setApplyFiltersFormiDI(initialFiltersFormDI);
    setFiltersFormDI(initialFiltersFormDI);
    setOpenEditFilterFormDI(false);
    seterrorsfiltersFormDI({});
    setNumTotRegFilter(0);
    setNumTotRegFormDI(0);
    setActiveOffsetFormDI(false);
    setCurrencyOffsetFormDI(0);
    setRangeOffsetFormDI([{}]);
    setShowModalSearchDI(false);
  };
  const toggleDrawerSearchFormDI = open => event => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      handleCloseDataEditFormDI();
    }
  };
  let inputHandlerFormDI = e => {
    var lowerCase = e.target.value.toLowerCase();
    setInputTextFormDI(lowerCase);
  };
  const openEditfiltersFormDI = () => {
    setFiltersFormDI(applyFiltersFormiDI);
    setOpenEditFilterFormDI(!openEditFilterFormDI);
  };
  const toggleDrawerFilterEditFormDI = open => event => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      event.preventDefault();
      handleCloseDataEditFormDI();
    }
  };
  const handleCancelfiltersFormDI = () => {
    seterrorsfiltersFormDI({});
    setFiltersFormDI(initialFiltersFormDI);
    setOpenEditFilterFormDI(!openEditFilterFormDI);
  };
  const handleChangeFilterEditFormDi = e => {
    const {
      name,
      value
    } = e.target;
    setFiltersFormDI(filtersFormDI => ({
      ...filtersFormDI,
      [name]: value
    }));
  };
  const handleBlurFilterEditFormDI = e => {
    seterrorsfiltersFormDI(validateFormFilterFormDI());
    handleChangeFilterEditFormDi(e);
  };
  const handleSubmitFilterEditFormDI = () => {
    seterrorsfiltersFormDI(validateFormFilterFormDI());
    if (Object.keys(errorsfiltersFormDI).length === 0) {
      setApplyFiltersFormiDI(filtersFormDI);
      setFiltersFormDI(initialFiltersFormDI);
      seterrorsfiltersFormDI({});
      setOpenEditFilterFormDI(false);
    } else {
      dispatch(warningErrorAction(t('Text_Error_Filter')));
    }
  };
  const handleDeletefiltersFormDI = () => {
    seterrorsfiltersFormDI({});
    setFiltersFormDI(initialFiltersFormDI);
    setApplyFiltersFormiDI(initialFiltersFormDI);
    setOpenEditFilterFormDI(!openEditFilterFormDI);
  };
  const handleChangeSelectDateSheetFrom = event => {
    setFiltersFormDI(filtersFormDI => ({
      ...filtersFormDI,
      dateSheetFrom: event !== null ? new Date(event) : null,
      dateSheetTo: null
    }));
  };
  const handleBlurSelectDateSheetFrom = e => {
    handleChangeSelectDateSheetFrom(e);
    seterrorsfiltersFormDI(validateFormFilterFormDI());
  };
  const handleChangeSelectDateSheetTo = event => {
    setFiltersFormDI(filtersFormDI => ({
      ...filtersFormDI,
      dateSheetTo: event !== null ? new Date(event) : null
    }));
  };
  const handleBlurSelectDateSheetTo = e => {
    handleChangeSelectDateSheetTo(e);
    seterrorsfiltersFormDI(validateFormFilterFormDI());
  };
  const validateFormFilterFormDI = () => {
    let errorsfiltersFormDI = {};
    let regexNumber = /^[0-9]+$/;
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;
    if (filtersFormDI.idFrom !== "" & !regexNumber.test(filtersFormDI.idFrom)) {
      errorsfiltersFormDI.idFrom = 'Text_TextNoNumber';
    }
    if (filtersFormDI.idTo !== "" & !regexNumber.test(filtersFormDI.idTo)) {
      errorsfiltersFormDI.idTo = 'Text_TextNoNumber';
    }
    if (filtersFormDI.idFrom !== "" & !errorsfiltersFormDI.idFrom !== undefined) {
      if (filtersFormDI.idTo !== "" & !errorsfiltersFormDI.idTo !== undefined) {
        if (parseInt(filtersFormDI.idTo) < parseInt(filtersFormDI.idFrom)) {
          errorsfiltersFormDI.idTo = 'Text_TextGreater_Id';
        }
      }
    }
    if (regexInvalidCharacters.test(filtersFormDI.preiddocSheetFrom)) {
      errorsfiltersFormDI.preiddocSheetFrom = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(filtersFormDI.preiddocSheetTo)) {
      errorsfiltersFormDI.preiddocSheetTo = 'Text_TextNoValid';
    }
    if (filtersFormDI.sufiddocSheetFrom !== "" & !regexNumber.test(filtersFormDI.sufiddocSheetFrom)) {
      errorsfiltersFormDI.sufiddocSheetFrom = 'Text_TextNoNumber';
    }
    if (filtersFormDI.sufiddocSheetTo !== "" & !regexNumber.test(filtersFormDI.sufiddocSheetTo)) {
      errorsfiltersFormDI.sufiddocSheetTo = 'Text_TextNoNumber';
    }
    if (regexInvalidCharacters.test(filtersFormDI.numberDTFrom)) {
      errorsfiltersFormDI.numberDTFrom = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(filtersFormDI.numberDTTo)) {
      errorsfiltersFormDI.numberDTTo = 'Text_TextNoValid';
    }
    if (filtersFormDI.preiddocSheetTo !== "" & filtersFormDI.preiddocSheetTo < filtersFormDI.preiddocSheetFrom) {
      errorsfiltersFormDI.preiddocSheetTo = 'Text_TextGreater_PreiddocSheet';
    }
    if (filtersFormDI.sufiddocSheetTo !== "" & filtersFormDI.sufiddocSheetTo < filtersFormDI.sufiddocSheetFrom) {
      errorsfiltersFormDI.sufiddocSheetTo = 'Text_TextGreater_SufiddocSheet';
    }
    if (filtersFormDI.numberDTTo !== "" & filtersFormDI.numberDTTo < filtersFormDI.numberDTFrom) {
      errorsfiltersFormDI.numberDTTo = 'Text_TextGreater_numberDTTo';
    }
    return errorsfiltersFormDI;
  };
  const filtereddataFormDI = dataFormDI.filter(el => {
    if (inputTextFormDI === '') {
      return el;
    } else {
      let dataTranslate = String(el.id || '') + String(el.preiddoc_sheet || '') + String(el.sufiddoc_sheet || '');
      let result = dataTranslate.toLowerCase().includes(inputTextFormDI.toLowerCase());
      return result;
    }
  });
  useEffect(() => {
    let isMounted = true;
    const fetchnumTotRegFormDI = async () => {
      dispatch(setLoading(true));
      try {
        const getData = await helpHttp().get11(ENDPOINT, `shipping/getinformationtableformdi`, token, "-1");
        if (getData.err) {
          setDataFormDI(initialStateFormDI);
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setNumTotRegFormDI(getData);
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData')));
      }
    };
    const fetchnumTotRegFilter = async () => {
      dispatch(setLoading(true));
      try {
        const getData = await helpHttp().post4(ENDPOINT, `shipping/getcountfilterformdi`, token, defaultStore.id, formShipping.rel_trans_store_id > 0 ? formShipping.rel_trans_store_id : "-1", formShipping.vehiclestore_licenseplate.replace(/[.-]/g, "").trim() !== "" ? formShipping.vehiclestore_licenseplate.replace(/[.-]/g, "") : "-1", applyFiltersFormiDI);
        if (getData.err || getData.message === "Load failed") {
          setDataFormDI(initialStateFormDI);
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setNumTotRegFilter(getData);
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData')));
      }
    };
    const fetchdataFormDI = async () => {
      dispatch(setLoading(true));
      try {
        const getData = await helpHttp().post6(ENDPOINT, `shipping/getformsdi`, token, currencyOffsetFormDI, LIMITPAGESIZE, defaultStore.id, formShipping.rel_trans_store_id > 0 ? formShipping.rel_trans_store_id : "-1", formShipping.vehiclestore_licenseplate.replace(/[.-]/g, "").trim() !== "" ? formShipping.vehiclestore_licenseplate.replace(/[.-]/g, "") : "-1", applyFiltersFormiDI);
        if (getData.err || getData.message === "Load failed") {
          setDataFormDI(initialStateFormDI);
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setDataFormDI(getData);
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData')));
      }
    };
    if (showModalSearchDI) {
      fetchnumTotRegFormDI();
      fetchnumTotRegFilter();
      fetchdataFormDI();
    }
    return () => {
      isMounted = false;
    };
  }, [t, i18n, token, dispatch, defaultStore.id, formShipping.rel_trans_store_id, formShipping.vehiclestore_licenseplate, applyFiltersFormiDI, currencyOffsetFormDI, showModalSearchDI, LIMITPAGESIZE]);
  return <>
      {showModalSearchDI && <div>
          <SwipeableDrawer PaperProps={{
        className: "shipping-search-panel shipping-lookup-panel"
      }} anchor='right' open={true} onClose={toggleDrawerSearchFormDI(false)} onOpen={toggleDrawerSearchFormDI(true)}>
            <Container maxWidth={false}>
              <Box sx={{
            bgcolor: '#ffffff',
            width: '100%',
            maxWidth: '100%'
          }}>
                <br />
                <div className="formdi-pending-header2"> 
                  <h1 className="formdi-pending-title">
                    {isLoadingErrorFormDI ? <i className="fas fa-solid fa-exclamation fa-2x text-danger"></i> : isLoading ? <CircularProgress color={"primary"} /> : <i className="fas fa-regular fa-clipboard text-warning"></i>} {t('Text_DIs_Search')}
                  </h1>
                  <div>
                    <button type="button" className="formdi-pending-btn formdi-pending-btn--primary" onClick={handleCloseDataEditFormDI}>{t('Button_Back')}</button><> </>
                  </div> 
                </div>  
                <br />  
                <div className="formdi-pending-search">
                  <TextField autoComplete="off" id="outlined-basic" variant="outlined" value={inputTextFormDI} inputProps={{
                style: {
                  fontSize: '18px'
                }
              }} InputLabelProps={{
                style: {
                  fontSize: '18px',
                  background: '#FFFFFF'
                }
              }} placeholder={t('Text_DI_Search')} onChange={inputHandlerFormDI} fullWidth label={t('Text_DI_Search')}>
                  </TextField>
                </div>
                <br />
                <div id="myNewDIV" className="formdi-pending-filters">
                  <h1 className="formdi-pending-filter-title">{t('Text_Filter')}</h1> 
                    <div className="formdi-pending-filters-row">
                      <button type="button" className={`formdi-pending-chip ${applyFiltersFormiDI.idFrom !== "" || applyFiltersFormiDI.idTo !== "" ? "formdi-pending-chip--active" : ""}`} onClick={openEditfiltersFormDI}>
                        <span className={`formdi-pending-dot ${applyFiltersFormiDI.idFrom !== "" || applyFiltersFormiDI.idTo !== "" ? "formdi-pending-dot--on" : ""}`} />
                        {t("Text_Code")}
                      </button>
                      <button type="button" className={`formdi-pending-chip ${applyFiltersFormiDI.preiddocSheetFrom !== "" || applyFiltersFormiDI.preiddocSheetTo !== "" ? "formdi-pending-chip--active" : ""}`} onClick={openEditfiltersFormDI}>
                        <span className={`formdi-pending-dot ${applyFiltersFormiDI.preiddocSheetFrom !== "" || applyFiltersFormiDI.preiddocSheetTo !== "" ? "formdi-pending-dot--on" : ""}`} />
                        {t("Text_Prefix")}
                      </button>
                      <button type="button" className={`formdi-pending-chip ${applyFiltersFormiDI.sufiddocSheetFrom !== "" || applyFiltersFormiDI.sufiddocSheetTo !== "" ? "formdi-pending-chip--active" : ""}`} onClick={openEditfiltersFormDI}>
                        <span className={`formdi-pending-dot ${applyFiltersFormiDI.sufiddocSheetFrom !== "" || applyFiltersFormiDI.sufiddocSheetTo !== "" ? "formdi-pending-dot--on" : ""}`} />
                        {t("Text_Sufix")}
                      </button>
                      <button type="button" className={`formdi-pending-chip ${applyFiltersFormiDI.numberDTFrom !== "" || applyFiltersFormiDI.numberDTTo !== "" || applyFiltersFormiDI.dateSheetFrom !== null || applyFiltersFormiDI.dateSheetTo !== null ? "formdi-pending-chip--active" : ""}`} onClick={openEditfiltersFormDI}>
                        <span className={`formdi-pending-dot ${applyFiltersFormiDI.numberDTFrom !== "" || applyFiltersFormiDI.numberDTTo !== "" || applyFiltersFormiDI.dateSheetFrom !== null || applyFiltersFormiDI.dateSheetTo !== null ? "formdi-pending-dot--on" : ""}`} />
                        {t("Text_Others_Filters")}
                      </button>
                  </div>
                </div>  
                <br />
                {!isLoading ? <>
                    <div className="formdi-pending-card-flat">
                      <div className="formdi-pending-card-content">
                      <TableSortingShippingFormDI dataFormDI={filtereddataFormDI} numTotRegFilter={numTotRegFilter} titleTable={t('Text_DIs_AVAILABLE')} numTotRegFormDI={numTotRegFormDI} activeOffsetFormDI={activeOffsetFormDI} rangeOffsetFormDI={rangeOffsetFormDI} currencyOffsetFormDI={currencyOffsetFormDI} setCurrencyOffsetFormDI={setCurrencyOffsetFormDI} handleCloseDataEditFormDI={handleCloseDataEditFormDI} setFormShipping={setFormShipping} menuPermissions={menuPermissions} formShipping={formShipping}>
                      </TableSortingShippingFormDI>
                      </div>             
                    </div>
                    {openEditFilterFormDI && <div>
                      <SwipeableDrawer PaperProps={{
                  className: "shipping-search-panel shipping-lookup-panel"
                }} anchor='right' open={true} onClose={toggleDrawerFilterEditFormDI(false)} onOpen={toggleDrawerFilterEditFormDI(true)}>
                        <Container maxWidth={false}>
                          <Box sx={{
                      bgcolor: '#ffffff',
                      minHeight: '100vh',
                      width: '100%',
                      maxWidth: '100%'
                    }}>
                            <br />
                              <div id="myDIV">
                                <h1 className="h1NewStyle px-4 mb-2">{t('Text_Filter')}</h1>
                              </div>
                              <hr className="sidebar-divider d-none d-md-block" />
                              <form autoComplete="off" className="shipping-search-filters newfilterformpruchasedi" onSubmit={handleCancelfiltersFormDI}>  
                                <div className="form-floating mb-3 px-4 primary">
                                  <div className="form-group">
                                    <TextField autoComplete="off" id="idFrom" name="idFrom" value={filtersFormDI.idFrom} inputProps={{
                              style: {
                                width: 350,
                                fontSize: '18px'
                              },
                              maxLength: 15
                            }} InputLabelProps={{
                              style: {
                                fontSize: '18px',
                                background: '#FFFFFF'
                              }
                            }} label={errorsfiltersFormDI.idFrom != null ? t(errorsfiltersFormDI.idFrom) : t('Text_Filter_Code_From')} placeholder={t('PlaceHolder_Filter_Code_From')} variant="outlined" onBlur={handleBlurFilterEditFormDI} onChange={handleChangeFilterEditFormDi} />
                                      
                                    <TextField autoComplete="off" id="idTo" name="idTo" value={filtersFormDI.idTo} inputProps={{
                              style: {
                                width: 350,
                                fontSize: '18px'
                              },
                              maxLength: 15
                            }} InputLabelProps={{
                              style: {
                                fontSize: '18px',
                                background: '#FFFFFF'
                              }
                            }} label={errorsfiltersFormDI.idTo != null ? t(errorsfiltersFormDI.idTo) : t('Text_Filter_Code_To')} placeholder={t('PlaceHolder_Filter_Code_to')} variant="outlined" onBlur={handleBlurFilterEditFormDI} onChange={handleChangeFilterEditFormDi} />
                                  </div>
                                  <div className="form-group">
                                    <TextField autoComplete="off" id="preiddocSheetFrom" name="preiddocSheetFrom" value={filtersFormDI.preiddocSheetFrom} inputProps={{
                              style: {
                                width: 350,
                                fontSize: '18px'
                              },
                              maxLength: 20
                            }} InputLabelProps={{
                              style: {
                                fontSize: '18px',
                                background: '#FFFFFF'
                              }
                            }} label={errorsfiltersFormDI.preiddocSheetFrom != null ? t(errorsfiltersFormDI.preiddocSheetFrom) : t('Text_Filter_PreiddocSheet_From')} placeholder={t('PlaceHolder_Filter_PreiddocSheet_From')} variant="outlined" onBlur={handleBlurFilterEditFormDI} onChange={handleChangeFilterEditFormDi} />
                                      
                                    <TextField autoComplete="off" id="preiddocSheetTo" name="preiddocSheetTo" value={filtersFormDI.preiddocSheetTo} inputProps={{
                              style: {
                                width: 350,
                                fontSize: '18px'
                              },
                              maxLength: 20
                            }} InputLabelProps={{
                              style: {
                                fontSize: '18px',
                                background: '#FFFFFF'
                              }
                            }} label={errorsfiltersFormDI.preiddocSheetTo != null ? t(errorsfiltersFormDI.preiddocSheetTo) : t('Text_Filter_PreiddocSheet_To')} placeholder={t('PlaceHolder_Filter_PreiddocSheet_To')} variant="outlined" onBlur={handleBlurFilterEditFormDI} onChange={handleChangeFilterEditFormDi} />
                                  </div>
                                  <div className="form-group">
                                    <TextField autoComplete="off" id="sufiddocSheetFrom" name="sufiddocSheetFrom" value={filtersFormDI.sufiddocSheetFrom} inputProps={{
                              style: {
                                width: 350,
                                fontSize: '18px'
                              },
                              maxLength: 15
                            }} InputLabelProps={{
                              style: {
                                fontSize: '18px',
                                background: '#FFFFFF'
                              }
                            }} label={errorsfiltersFormDI.sufiddocSheetFrom != null ? t(errorsfiltersFormDI.sufiddocSheetFrom) : t('Text_Filter_SufiddocSheet_From')} placeholder={t('PlaceHolder_Filter_SufiddocSheet_From')} variant="outlined" onBlur={handleBlurFilterEditFormDI} onChange={handleChangeFilterEditFormDi} />
                                      
                                    <TextField autoComplete="off" id="sufiddocSheetTo" name="sufiddocSheetTo" value={filtersFormDI.sufiddocSheetTo} inputProps={{
                              style: {
                                width: 350,
                                fontSize: '18px'
                              },
                              maxLength: 15
                            }} InputLabelProps={{
                              style: {
                                fontSize: '18px',
                                background: '#FFFFFF'
                              }
                            }} label={errorsfiltersFormDI.sufiddocSheetTo != null ? t(errorsfiltersFormDI.sufiddocSheetTo) : t('Text_Filter_SufiddocSheet_To')} placeholder={t('PlaceHolder_Filter_SufiddocSheet_To')} variant="outlined" onBlur={handleBlurFilterEditFormDI} onChange={handleChangeFilterEditFormDi} />
                                  </div>
                                  <div className="form-group">
                                    <TextField autoComplete="off" id="numberDTFrom" name="numberDTFrom" value={filtersFormDI.numberDTFrom} inputProps={{
                              style: {
                                width: 350,
                                fontSize: '18px'
                              },
                              maxLength: 15
                            }} InputLabelProps={{
                              style: {
                                fontSize: '18px',
                                background: '#FFFFFF'
                              }
                            }} label={errorsfiltersFormDI.numberDTFrom != null ? t(errorsfiltersFormDI.numberDTFrom) : t('Text_Filter_NumberNT_From')} placeholder={t('PlaceHolder_Filter_NumberNT_From')} variant="outlined" onBlur={handleBlurFilterEditFormDI} onChange={handleChangeFilterEditFormDi} />
                                      
                                    <TextField autoComplete="off" id="numberDTTo" name="numberDTTo" value={filtersFormDI.numberDTTo} inputProps={{
                              style: {
                                width: 350,
                                fontSize: '18px'
                              },
                              maxLength: 15
                            }} InputLabelProps={{
                              style: {
                                fontSize: '18px',
                                background: '#FFFFFF'
                              }
                            }} label={errorsfiltersFormDI.numberDTTo != null ? t(errorsfiltersFormDI.numberDTTo) : t('Text_Filter_NumberNT_To')} placeholder={t('PlaceHolder_Filter_NumberNT_To')} variant="outlined" onBlur={handleBlurFilterEditFormDI} onChange={handleChangeFilterEditFormDi} />
                                  </div>

                                  <div className="form-group">
                                  <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
                                      <DesktopDatePicker id="dateSheetFrom" name="dateSheetFrom" value={filtersFormDI.dateSheetFrom !== null ? new Date(filtersFormDI.dateSheetFrom) : null} format={i18n.language === "es" ? "dd/MM/yyyy" : "MM/dd/yyyy"} label={errorsfiltersFormDI.dateSheetFrom != null ? t(errorsfiltersFormDI.dateSheetFrom) : t('PlaceHolder_Filter_DateSheet_From')} onBlur={handleBlurSelectDateSheetFrom} onChange={handleChangeSelectDateSheetFrom} slotProps={{
                                textField: {
                                  autoComplete: "off",
                                  placeholder: i18n.language === "es" ? "dd/MM/yyyy" : "MM/dd/yyyy",
                                  sx: {
                                    color: '#1565c0',
                                    maxLength: '100',
                                    width: '100%',
                                    fontSize: '18px'
                                  },
                                  InputProps: {
                                    style: {
                                      fontSize: '18px'
                                    }
                                  },
                                  InputLabelProps: {
                                    style: {
                                      fontSize: '18px',
                                      background: '#FFFFFF'
                                    }
                                  }
                                }
                              }} />
                                    </LocalizationProvider>
                                     
                                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
                                      <DesktopDatePicker id="dateSheetTo" name="dateSheetTo" minDate={filtersFormDI.dateSheetFrom !== null ? new Date(filtersFormDI.dateSheetFrom) : null} value={filtersFormDI.dateSheetTo !== null ? new Date(filtersFormDI.dateSheetTo) : null} format={i18n.language === "es" ? "dd/MM/yyyy" : "MM/dd/yyyy"} label={errorsfiltersFormDI.dateSheetTo != null ? t(errorsfiltersFormDI.dateSheetTo) : t('PlaceHolder_Filter_DateSheet_To')} onBlur={handleBlurSelectDateSheetTo} onChange={handleChangeSelectDateSheetTo} slotProps={{
                                textField: {
                                  autoComplete: "off",
                                  placeholder: i18n.language === "es" ? "dd/MM/yyyy" : "MM/dd/yyyy",
                                  sx: {
                                    color: '#1565c0',
                                    maxLength: '100',
                                    width: '100%',
                                    fontSize: '18px'
                                  },
                                  InputProps: {
                                    style: {
                                      fontSize: '18px'
                                    }
                                  },
                                  InputLabelProps: {
                                    style: {
                                      fontSize: '18px',
                                      background: '#FFFFFF'
                                    }
                                  }
                                }
                              }} />
                                    </LocalizationProvider>
                                  </div> 
                                </div>
                                <hr className="sidebar-divider d-none d-md-block" />
                                <div className="formdi-pending-action-group">
                                  <button className="formdi-pending-action-btn formdi-pending-action-btn--primary" type="button" onClick={handleSubmitFilterEditFormDI}>
                                    {t('Button_Apply')}
                                  </button> 
                                  <button className="formdi-pending-action-btn formdi-pending-action-btn--secondary" type="button" onClick={handleDeletefiltersFormDI}>
                                    {t('Button_Cancel_Filters')}
                                  </button>
                                </div>  
                            </form>
                          </Box>
                        </Container>
                      </SwipeableDrawer>
                    </div>}  
                  
                  {/* End Content Row */}
                  </> : <LoadingNews />} 
              </Box>
            </Container>
          </SwipeableDrawer>
        </div>}  
    </>;
};
ShippingSearchDI.propTypes = {
  showModalSearchDI: PropTypes.bool.isRequired,
  setShowModalSearchDI: PropTypes.func.isRequired,
  setFormShipping: PropTypes.func.isRequired
};
export default ShippingSearchDI;